import React, { useEffect, useState } from 'react';
import {
  Button,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  makeStyles
} from '@material-ui/core';

import Dialog from '../../ui/Dialog';
import LoadingOverlay from '../../LoadingOverlay/LoadingOverlay.component';
import { validateSelfEnrolledPatient } from '../../../services/customer.service';
import { getAllPrivateHospital } from '../../../services/user.service';

const useStyles = makeStyles(() => ({
  field: {
    marginBottom: 10,
    width: '100%'
  },
  select: {
    width: '100%'
  },
  formControl: {
    width: '100%'
  }
}));

const ApproveSelfEnrolledPatient = ({ data }) => {
  const { patient_id, program_id } = data;
  const classes = useStyles();
  const [selectedPrivateHospital, setSelectedPrivateHospital] = useState('');
  const [privateHospitalList, setPrivateHospitalList] = useState([]);

  useEffect(() => {
    const getPrivateHospitals = async () => {
      const { result } = await getAllPrivateHospital({ program_id });

      setPrivateHospitalList(result);
    }

    getPrivateHospitals();    
  }, []);

  const [state, setState] = useState({
    openModal: true,
    openConfirmation: false,
    modalTitle: 'Approve Registration',
    errorMessage: null,
    successMessage: 'Patient Registration has been Approved!',
    isLoading: false,
    latestMessage: '',
    messageLogId: null,
    submitButtonEnabled: false,
  });

  const handleClose = () => {
    const { openConfirmation } = state;
    setState(prev => ({
      ...prev,
      openModal: false,
      openConfirmation: false,
      errorMessage: null
    }));

    if (openConfirmation) {
      window.location.reload();
    }
  };

  const onApprove = async () => {
    setState(prev => ({ ...prev, isLoading: true }));

    try {
      const { message } = await validateSelfEnrolledPatient({
        customer_id: patient_id,
        program_id,
        action: 'approve',
        payload: {
          private_hospital_user_id: selectedPrivateHospital,
        }
      });

      setState(prev => ({
        ...prev,
        openConfirmation: true,
        openModal: false,
        successMessage: message
      }));
    } catch (e) {
      setState(prev => ({
        ...prev,
        errorMessage: e.message
      }));
    } finally {
      setState(prev => ({ ...prev, isLoading: false }));
    }
  };

  const {
    openModal,
    openConfirmation,
    modalTitle,
    errorMessage,
    successMessage,
    isLoading,
    submitButtonEnabled
  } = state;

  const onActionSelect = (e) => {
    if (e && e.target && e.target.value) {
      setSelectedPrivateHospital(e.target.value);
      setState(prev => ({
        ...prev,
        submitButtonEnabled: true
      }));
    } else {
      setState(prev => ({
        ...prev,
        submitButtonEnabled: false
      }));
    }
  }

  if (isLoading) return <LoadingOverlay />;

  const formContent = (
    <Grid container spacing={2}>
      <Grid item xs={12}>
          <InputLabel>Select Private Hospital</InputLabel>
          <Select
            required={true}
            name="action_dropdown"
            variant='outlined' 
            className={classes.field}
            onChange={onActionSelect}
            value={selectedPrivateHospital}
          >
            {
                privateHospitalList && privateHospitalList.length ? privateHospitalList?.map(privateHospital => {
                  return <MenuItem key={privateHospital.id} value={privateHospital.id}>
                      {privateHospital.metadata.clinic_name}
                  </MenuItem>
                }) : <></>
            }
        </Select>
      </Grid>
      {errorMessage && (
        <Grid item xs={12}>
          <Typography variant="caption" color="error">
            {errorMessage}
          </Typography>
        </Grid>
      )}
    </Grid>
  );

  const formButtons = (
    <>
      <Button onClick={handleClose} variant="contained">
        {openConfirmation ? 'OK' : 'Close'}
      </Button>
      {
        !openConfirmation && 
        <Button
          onClick={onApprove}
          variant="contained"
          color="primary"
          disabled={!submitButtonEnabled}
        >
          Approve
        </Button>
      }
    </>
  );

  return (
    <>
      <Dialog
        key="approve-self-enrolled-patient"
        open={openModal}
        title={modalTitle}
        content={formContent}
        children={formButtons}
        onSubmit={onApprove}
        onClose={handleClose}
      />
      <Dialog 
        onSubmit={handleClose}
        key="confirmation"
        open={openConfirmation}
        title="Approved Registration"
        content={successMessage}
        children={formButtons}
        onClose={handleClose}
      />
    </>
  );
};

export default ApproveSelfEnrolledPatient;